import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HeadersModule } from '@shared/core/components/headers';
import { ListForHistoryOrdersModule } from '@shared/core/components/lists/listsTypes/forHistoryOrders';

import { ReorderingComponent } from './reordering.shared.component';

@NgModule({
    declarations: [
        ReorderingComponent,
    ],
    imports: [
        CommonModule,
        HeadersModule,
        ListForHistoryOrdersModule,
    ],
    exports: [
        ReorderingComponent,
    ],
})
export class ReorderingModule { }
